// 菜单 侧边栏
export default [
  { path: '/index', title: '首页', icon: 'home' },
  { path: '/demo/miniProgramQrCode', title: '小程序码生成', icon: 'qrcode' }
  // {
  //   path: "/demo",
  //   title: "小程序商城管理",
  //   icon: "folder-o",
  //   children: [
  //     {
  //       title: "page1",
  //       children: [{path: "/demo/page1", title: "页面 1"}],
  //     },
  //     { path: "/demo/page2", title: "页面 2" },
  //     { path: "/demo/page3", title: "页面 3" },
  //     {
  //       title: "page4",
  //       children: [{ path: "/demo/page4", title: "page4" }],
  //     },
  //   ],
  // },
]
